import { ContentBlocks } from "eddev/blocks"
import { defineView } from "eddev/views"
import { PageProvider } from "../contexts/PageContext"
import { NewsArchive } from "@components/news/NewsArchive"
import { SiteFooter } from "@components/site/SiteFooter"

export const meta: ViewMeta = {
  templateName: "News",
}

export default defineView("template-news", (props) => {
  return (
    <PageProvider {...props.page?.page}>
      <ContentBlocks blocks={props.page?.contentBlocks} />
      <NewsArchive
        items={props.newss?.nodes!}
        cats={props.newsCats?.nodes!}
        tags={props.newsTags?.nodes!}
        layout="index"
      />
      <SiteFooter />
    </PageProvider>
  )
})
